/* eslint-disable react/require-default-props */
/* eslint no-unused-expressions: "off" */
import { FormEventHandler } from 'react';
import { SubmitHandler, useForm, UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TreeCompany, TreeTeam } from '../../../../api/model';
import Modal from '../../../modules/Modal';

type Props = {
  companyIndex: number;
  groupIndex: number;
  teamIndex?: number;
  open: boolean;
  onClose: () => void;
  setValue: UseFormSetValue<{ companies: TreeCompany[] }>;
  getValues: UseFormGetValues<{ companies: TreeCompany[] }>;
  /* eslint @typescript-eslint/no-explicit-any: 0 */
  append?: (params: any) => void;
};
function TeamModal({ companyIndex, groupIndex, teamIndex, open, onClose, setValue, getValues, append }: Props) {
  const {
    register,
    getValues: getModalValues,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<TreeTeam>({
    defaultValues: {
      team_name_ja:
        teamIndex !== undefined
          ? getValues(`companies.${companyIndex}.groups.${groupIndex}.teams.${teamIndex}.team_name_ja`)
          : '',
      team_name_en:
        teamIndex !== undefined
          ? getValues(`companies.${companyIndex}.groups.${groupIndex}.teams.${teamIndex}.team_name_en`)
          : '',
    },
  });

  const { t } = useTranslation();

  const handleSubmitWithoutPropagation: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();
    void handleSubmit(onSubmit)();
  };
  const onSubmit: SubmitHandler<TreeCompany> = () => {
    const teamNameJa = getModalValues('team_name_ja') || '';
    const teamNameEn = getModalValues('team_name_en') || '';

    if (teamIndex !== undefined) {
      setValue(`companies.${companyIndex}.groups.${groupIndex}.teams.${teamIndex}.team_name_ja`, teamNameJa);
      setValue(`companies.${companyIndex}.groups.${groupIndex}.teams.${teamIndex}.team_name_en`, teamNameEn);
    } else {
      append &&
        append({
          team_id: null,
          team_name_ja: teamNameJa,
          team_name_en: teamNameEn,
          hidden: 0,
        });
    }
    onClose();
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Modal active={open} additionalClassName="popupfr800" displayCloseButton onClose={handleClose}>
      <form onSubmit={handleSubmitWithoutPropagation}>
        <div className="popupfr pt30 popupfr644">
          <div className="teamsep2">
            <div>
              <label htmlFor="group_name_ja">{t('チーム（日）')}</label>
              <input type="text" {...register('team_name_ja', { required: true })} />
              {errors.team_name_ja?.type === 'required' && (
                <p className="errormessage show">{t('チーム（日）は必須項目です')}</p>
              )}
            </div>
            <div>
              <label htmlFor="group_name_en">{t('チーム（英）')}</label>
              <input type="text" {...register('team_name_en', { required: true })} />
              {errors.team_name_en?.type === 'required' && (
                <p className="errormessage show">{t('チーム（英）は必須項目です')}</p>
              )}
            </div>
          </div>
          <div className="btnfr btnfr2 mb0">
            <div>
              <span className="btn2 btnbg-g mr10">
                <span className="modal-close2" onClick={handleClose}>
                  {t('キャンセル')}
                </span>
              </span>
              <span>
                <input type="submit" value={t('更新').toString()} className="btn1 lsp1" />
              </span>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
}
export { TeamModal };
